import { render } from "./CredibilityStrip.vue?vue&type=template&id=de71d042&scoped=true"
const script = {}

import "./CredibilityStrip.vue?vue&type=style&index=0&id=de71d042&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de71d042"]])

export default __exports__